import { render, staticRenderFns } from "./TabContentMain.vue?vue&type=template&id=712a75b8&scoped=true"
import script from "./TabContentMain.vue?vue&type=script&lang=js"
export * from "./TabContentMain.vue?vue&type=script&lang=js"
import style0 from "./TabContentMain.vue?vue&type=style&index=0&id=712a75b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "712a75b8",
  null
  
)

export default component.exports